module.exports = __webpack_public_path__ + "img/Robert_Raich.bd8cd767.jpg";